import {
  GET_COMPAY_BONUSES_START,
  GET_COMPAY_BONUSES_SUCCESS,
  GET_COMPAY_BONUSES_FAIL,
  POST_CREATE_COMPANY_START,
  POST_CREATE_COMPANY_SUCCESS,
  POST_CREATE_COMPANY_FAIL,
  DELETE_COMPANY_START,
  DELETE_COMPANY_SUCCESS,
  DELETE_COMPANY_FAIL,
  GET_BRANCHES_BONUSES_START,
  GET_BRANCHES_BONUSES_SUCCESS,
  GET_BRANCHES_BONUSES_FAIL,
  GET_PACKAGES_START,
  GET_PACKAGES_SUCCESS,
  GET_PACKAGES_FAIL,
  CREATE_SERVICE_START,
  CREATE_SERVICE_SUCCESS,
  CREATE_SERVICE_FAIL,
  DELETE_SERVICE_START,
  DELETE_SERVICE_SUCCESS,
  DELETE_SERVICE_FAIL,
  CREATE_CARD_START,
  CREATE_CARD_SUCCESS,
  CREATE_CARD_FAIL,
  UPLOAD_FILE_START,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAIL,
  GET_EVENTS_START,
  GET_EVENTS_SUCCESS,
  GET_EVENTS_FAIL,
  GET_EVENT_START,
  GET_EVENT_SUCCESS,
  GET_EVENT_FAIL,
  GET_TRIGGERS_START,
  GET_TRIGGERS_SUCCESS,
  GET_TRIGGERS_FAIL,
  PATCH_UPDATE_EVENT_START,
  PATCH_UPDATE_EVENT_SUCCESS,
  PATCH_UPDATE_EVENT_FAIL,
  PATCH_SET_ARCHIVED_CARD_START,
  PATCH_SET_ARCHIVED_CARD_SUCCESS,
  PATCH_SET_ARCHIVED_CARD_FAIL,
  GET_CMS_PACKAGES_START,
  GET_CMS_PACKAGES_FAIL,
  GET_CMS_PACKAGES_SUCCESS,
  GET_COPY_EVENT_START,
  GET_COPY_EVENT_SUCCESS,
  GET_COPY_EVENT_FAIL,
  GET_BONUS_RECORDS_START,
  GET_BONUS_RECORDS_SUCCESS,
  GET_BONUS_RECORDS_FAIL,
  GET_BONUS_RECORD_START,
  GET_BONUS_RECORD_SUCCESS,
  GET_BONUS_RECORD_FAIL,
  GET_BONUS_RECORD_HISTORY_START,
  GET_BONUS_RECORD_HISTORY_SUCCESS,
  GET_BONUS_RECORD_HISTORY_FAIL,
  GET_SUBSCRIBERS_LIST_START,
  GET_SUBSCRIBERS_LIST_FAIL,
  GET_SUBSCRIBERS_LIST_SUCCESS,
  DELETE_FILE_START,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAIL,
  POST_ON_APPROVE_START,
  POST_ON_APPROVE_SUCCESS,
  POST_ON_APPROVE_FAIL,
  PATCH_APPROVE_START,
  PATCH_APPROVE_SUCCESS,
  PATCH_APPROVE_FAIL,
  GET_BONUSES_PACKAGES_START,
  GET_BONUSES_PACKAGES_SUCCESS,
  GET_BONUSES_PACKAGES_FAIL,
  POST_BONUSES_PACKAGES_START,
  POST_BONUSES_PACKAGES_SUCCESS,
  POST_BONUSES_PACKAGES_FAIL,
  PATCH_BONUSES_PACKAGE_START,
  PATCH_BONUSES_PACKAGE_SUCCESS,
  PATCH_BONUSES_PACKAGE_FAIL,
  PATCH_BONUSES_PACKAGE_STATUS_START,
  PATCH_BONUSES_PACKAGE_STATUS_SUCCESS,
  PATCH_BONUSES_PACKAGE_STATUS_FAIL,
  DELETE_BONUSES_PACKAGE_START,
  DELETE_BONUSES_PACKAGE_SUCCESS,
  DELETE_BONUSES_PACKAGE_FAIL,
  GET_BONUS_PACKAGE_START,
  GET_BONUS_PACKAGE_SUCCESS,
  GET_BONUS_PACKAGE_FAIL
} from './constants';

export const bonusesReducer = (
  state = {
    companyBonuses: [],
    branches: [],
    packages: [],
    package: null,
    cms: [],
    eventCards: [],
    eventCard: {},
    triggers: [],
    uploadFiles: [],
    statusUpdateEvent: false,
    fetching: false,
    updateServices: false,
    error: {},
    errorCard: {},
    instanceId: null,
    fetchingBonusRecord: false,
    fetchingBonusRecords: false,
    bonusRecord: {},
    bonusRecords: {},
    bonusRecordError: null,
    bonusRecordsError: null,
    bonusRecordHistory: [],
    bonusRecordHistoryFetching: false,
    bonusRecordHistoryError: null,
    subscribersList: {}
  },
  action
) => {
  switch (action.type) {
    case GET_COMPAY_BONUSES_START:
      return { ...state, fetching: true };
    case GET_COMPAY_BONUSES_SUCCESS:
      return {
        ...state,
        fetching: false,
        companyBonuses: action.payload
      };
    case GET_COMPAY_BONUSES_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case GET_BRANCHES_BONUSES_START:
      return { ...state, fetching: true };
    case GET_BRANCHES_BONUSES_SUCCESS:
      return {
        ...state,
        fetching: false,
        branches: action.payload.map(({ id, name }) => ({ id, label: name }))
      };
    case GET_BRANCHES_BONUSES_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case GET_PACKAGES_START:
      return { ...state, fetching: true };
    case GET_PACKAGES_SUCCESS:
      return { ...state, fetching: false, packages: action.payload };
    case GET_PACKAGES_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case GET_CMS_PACKAGES_START:
      return { ...state, fetching: true };
    case GET_CMS_PACKAGES_SUCCESS:
      return { ...state, fetching: false, cms: action.payload };
    case GET_CMS_PACKAGES_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case POST_CREATE_COMPANY_START:
      return { ...state, fetching: true };
    case POST_CREATE_COMPANY_SUCCESS:
      return {
        ...state,
        fetching: false,
        companyBonuses: [
          { ...action.payload?.data?.instance, label: action.payload?.data?.instance.name },
          ...state.companyBonuses
        ]
      };
    case POST_CREATE_COMPANY_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case DELETE_COMPANY_START:
      return { ...state, fetching: true };
    case DELETE_COMPANY_SUCCESS:
      return {
        ...state,
        fetching: false,
        companyBonuses: state.companyBonuses.filter((company) => company.id !== action.payload)
      };
    case DELETE_COMPANY_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case CREATE_SERVICE_START:
      return { ...state, fetching: true, updateServices: true };
    case CREATE_SERVICE_SUCCESS:
      return {
        ...state,
        fetching: false,
        updateServices: false,
        companyBonuses: state.companyBonuses.map((company) =>
          action.payload?.data?.data.instance?.company_id === company.id
            ? { ...company, services: [action.payload?.data?.data.instance, ...company.services] }
            : { ...company }
        )
      };
    case CREATE_SERVICE_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case DELETE_SERVICE_START:
      return { ...state, fetching: true, updateServices: true };
    case DELETE_SERVICE_SUCCESS:
      return {
        ...state,
        fetching: false,
        updateServices: false,
        companyBonuses: state.companyBonuses.map((company) => ({
          ...company,
          services: action.payload.status
            ? company.services.filter(({ id }) => id !== action.payload.id)
            : [...company.services]
        }))
      };
    case DELETE_SERVICE_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case CREATE_CARD_START:
      return { ...state, fetching: true, errorCard: {} };
    case CREATE_CARD_SUCCESS:
      return {
        ...state,
        instanceId: action.payload?.data?.instance || action.payload?.data?.data?.instance,
        fetching: false,
        errorCard: action
      };
    case CREATE_CARD_FAIL:
      return { ...state, fetching: false, errorCard: action.payload };

    case UPLOAD_FILE_START:
      return { ...state, fetching: true };
    case UPLOAD_FILE_SUCCESS:
      return { ...state, fetching: false, uploadFiles: [...state.uploadFiles, action.payload] };
    case UPLOAD_FILE_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case DELETE_FILE_START:
      return { ...state, fetching: true };
    case DELETE_FILE_SUCCESS:
      return {
        ...state,
        fetching: false,
        uploadFiles: state.uploadFiles.filter((item) => item !== action.payload)
      };
    case DELETE_FILE_FAIL:
      return { ...state, fetching: false, errorCard: action.payload };

    case GET_EVENTS_START:
      return { ...state, fetching: true, eventCard: {}, errorCard: {} };
    case GET_EVENTS_SUCCESS:
      return { ...state, fetching: false, eventCards: action.payload };
    case GET_EVENTS_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case GET_BONUS_RECORDS_START:
      return { ...state, fetchingBonusRecords: true, bonusRecords: {}, bonusRecordsError: null };
    case GET_BONUS_RECORDS_SUCCESS:
      return { ...state, fetchingBonusRecords: false, bonusRecords: action.payload };
    case GET_BONUS_RECORDS_FAIL:
      return { ...state, fetchingBonusRecords: false, bonusRecordsError: action.payload };

    case GET_BONUS_RECORD_START:
      return { ...state, fetchingBonusRecord: true, bonusRecord: {}, bonusRecordError: null };
    case GET_BONUS_RECORD_SUCCESS:
      return { ...state, fetchingBonusRecord: false, bonusRecord: action.payload };
    case GET_BONUS_RECORD_FAIL:
      return { ...state, fetchingBonusRecord: false, bonusRecordError: action.payload };

    case GET_BONUS_RECORD_HISTORY_START:
      return {
        ...state,
        bonusRecordHistoryFetching: true,
        bonusRecordHistory: [],
        bonusRecordHistoryError: null
      };
    case GET_BONUS_RECORD_HISTORY_SUCCESS:
      return { ...state, bonusRecordHistoryFetching: false, bonusRecordHistory: action.payload };
    case GET_BONUS_RECORD_HISTORY_FAIL:
      return {
        ...state,
        bonusRecordHistoryFetching: false,
        bonusRecordHistoryError: action.payload
      };

    case GET_COPY_EVENT_START:
    case GET_EVENT_START:
      return { ...state, fetching: true, eventCard: {} };
    case GET_COPY_EVENT_SUCCESS:
    case GET_EVENT_SUCCESS:
      return { ...state, fetching: false, eventCard: action.payload };
    case GET_COPY_EVENT_FAIL:
    case GET_EVENT_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case GET_TRIGGERS_START:
      return { ...state, fetching: true };
    case GET_TRIGGERS_SUCCESS:
      return { ...state, fetching: false, triggers: action.payload };
    case GET_TRIGGERS_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case PATCH_UPDATE_EVENT_START:
      return { ...state, fetching: true };
    case PATCH_UPDATE_EVENT_SUCCESS:
      return { ...state, fetching: false, statusUpdateEvent: action.payload };
    case PATCH_UPDATE_EVENT_FAIL:
      return { ...state, fetching: false, statusUpdateEvent: false, errorCard: action.payload };

    case PATCH_SET_ARCHIVED_CARD_START:
      return { ...state, fetching: true };
    case PATCH_SET_ARCHIVED_CARD_SUCCESS:
      return {
        ...state,
        fetching: false,
        eventCard: { ...state.eventCard, status: 'Архив' },
        eventCards: {
          ...state.eventCards,
          items: state.eventCards?.items?.map((card) =>
            card?.id === action.payload?.id ? { ...card, status: 'Архив' } : card
          )
        }
      };
    case PATCH_SET_ARCHIVED_CARD_FAIL:
      return { ...state, fetching: false };

    case POST_ON_APPROVE_START:
      return { ...state, fetching: true };
    case POST_ON_APPROVE_SUCCESS:
      return {
        ...state,
        fetching: false,
        eventCard: { ...state.eventCard, status: 'На одобрении' },
        eventCards: {
          ...state.eventCards,
          items: state.eventCards?.items?.map((card) =>
            card?.id === action.payload?.id ? { ...card, status: 'На одобрении' } : card
          )
        }
      };
    case POST_ON_APPROVE_FAIL:
      return { ...state, fetching: false };

    case PATCH_APPROVE_START:
      return { ...state, fetching: true };
    case PATCH_APPROVE_SUCCESS:
      return {
        ...state,
        fetching: false,
        eventCard: {
          ...state.eventCard,
          status: action.payload.status,
          reason: action.payload.reason
        },
        eventCards: {
          ...state.eventCards,
          items: state.eventCards?.items?.map((card) =>
            card?.id === action.payload?.id
              ? { ...card, status: action.payload.status, reason: action.payload.reason }
              : card
          )
        }
      };
    case PATCH_APPROVE_FAIL:
      return { ...state, fetching: false };

    case GET_SUBSCRIBERS_LIST_START:
      return { ...state, fetching: true };
    case GET_SUBSCRIBERS_LIST_SUCCESS:
      return { ...state, subscribersList: action.payload, fetching: false };
    case GET_SUBSCRIBERS_LIST_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case GET_BONUSES_PACKAGES_START:
      return { ...state, fetching: true };
    case GET_BONUSES_PACKAGES_SUCCESS:
      return { ...state, fetching: false, packages: action.payload };
    case GET_BONUSES_PACKAGES_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case GET_BONUS_PACKAGE_START:
      return { ...state, fetching: true };
    case GET_BONUS_PACKAGE_SUCCESS:
      return { ...state, fetching: false, package: action.payload };
    case GET_BONUS_PACKAGE_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case POST_BONUSES_PACKAGES_START:
      return { ...state, fetching: true };
    case POST_BONUSES_PACKAGES_SUCCESS:
      return { ...state, fetching: false, packages: action.payload };
    case POST_BONUSES_PACKAGES_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case PATCH_BONUSES_PACKAGE_START:
      return { ...state, fetching: true };
    case PATCH_BONUSES_PACKAGE_SUCCESS:
      return { ...state, fetching: false, packages: action.payload };
    case PATCH_BONUSES_PACKAGE_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case PATCH_BONUSES_PACKAGE_STATUS_START:
      return { ...state, fetching: true };
    case PATCH_BONUSES_PACKAGE_STATUS_SUCCESS:
      return {
        ...state,
        fetching: false,
        packages: {
          ...state.packages,
          packages: state.packages.packages.map((pkg) => {
            if (pkg.id === action.payload.id) {
              return {
                ...pkg,
                status: action.payload.status
              };
            }
            return pkg;
          })
        }
      };
    case PATCH_BONUSES_PACKAGE_STATUS_FAIL:
      return { ...state, fetching: false, error: action.payload };

    case DELETE_BONUSES_PACKAGE_START:
      return { ...state, fetching: true };
    case DELETE_BONUSES_PACKAGE_SUCCESS:
      return {
        ...state,
        fetching: false,
        packages: {
          ...state.packages,
          packages: state.packages.packages.filter((pkg) => pkg.id !== action.payload)
        }
      };
    case DELETE_BONUSES_PACKAGE_FAIL:
      return { ...state, fetching: false, error: action.payload };

    default:
      return state;
  }
};
